{
  "page": {
    "title": "Data seeder",
    "description": "Creates test talents with avatars and pins through the regular API. Development and QA only.",
    "frameTitle": "Talents",
    "viewModeConfig": "Config",
    "viewModeResult": "Preview",
    "viewModeSplit": "Split",
    "hostNotAllowed": "The data seeder runs only on localhost, development and QA.",
    "sidebarLink": "Data seeder"
  },
  "config": {
    "presets": "Presets",
    "preset": {
      "quick": "10 quick",
      "heavy-shortlist": "Heavy shortlist 500",
      "edge-cases": "Edge cases"
    },
    "basics": "Batch",
    "seed": "Seed",
    "seedHelp": "Same seed and settings give the same people.",
    "newSeed": "New seed",
    "count": "Talents",
    "resourceType": "Resource type",
    "membership": "Visibility",
    "names": "Name origins",
    "namesHelp": "Weight per language; 0 leaves it out.",
    "locale": {
      "en": "English",
      "pl": "Polish",
      "de": "German",
      "fr": "French",
      "it": "Italian",
      "es": "Spanish",
      "ja": "Japanese",
      "pt_BR": "Brazilian"
    },
    "details": "Details",
    "fill": {
      "email": "Email",
      "phone": "Phone",
      "role": "Role"
    },
    "avatars": "Avatars",
    "avatarsHelp": "Weight per style; faces are drawn from the seed.",
    "rerollFaces": "Other faces",
    "avatarSource": {
      "lorelei": "Lorelei",
      "notionists": "Notionists",
      "avataaars": "Avataaars",
      "open-peeps": "Open Peeps",
      "micah": "Micah",
      "personas": "Personas",
      "photo": "Photos",
      "none": "No avatar"
    },
    "pins": "Pins",
    "pinCount": "Pins per talent: {{min}}–{{max}}",
    "portraitShare": "Portrait: {{percent}}%",
    "pinSource": {
      "photos": "Photos",
      "faces": "Faces"
    },
    "edgeCases": "Edge cases: {{percent}}%",
    "edgeCasesHelp": "Very long or non-Latin names, talents with nothing filled in, 40 pins.",
    "shortlist": "Shortlist",
    "createShortlist": "Add the batch to a new shortlist",
    "shortlistTitle": "Title",
    "shortlistWorkspace": "Workspace",
    "shortlistTeam": "Team",
    "noWorkspace": "Organisation (no workspace)",
    "pickTeam": "Pick a team",
    "run": "Create {{count}} talents"
  },
  "preview": {
    "title": "Preview: first {{shown}} of {{count}}",
    "loadFailed": "The preview could not be drawn: {{message}}",
    "noDetails": "No details",
    "pinCount_one": "{{count}} pin",
    "pinCount_other": "{{count}} pins"
  },
  "run": {
    "talents": "Creating talents: {{done}} of {{total}}",
    "shortlist": "Filling the shortlist…",
    "stopping": "Stopping after the talents in progress…",
    "stop": "Stop",
    "failures_one": "{{count}} failed",
    "failures_other": "{{count}} failed",
    "failure": "#{{index}}: {{message}}",
    "status": {
      "done": "Batch created",
      "stopped": "Stopped",
      "auto-stopped": "Stopped after 5 errors in a row",
      "restored": "Last batch"
    },
    "created_one": "{{count}} talent created",
    "created_other": "{{count}} talents created",
    "batchTag": "Tag {{tag}}",
    "showTalents": "Show the talents",
    "openShortlist": "Open the shortlist",
    "shortlistFailed": "The shortlist failed: {{message}}",
    "archive": "Archive this batch",
    "archived": "Archived",
    "failed": "The run failed: {{message}}"
  }
}
